export const rbItems = [
  {
    link: "/rb1403/blog?search=معرفی_روضه_راه_بهشت_۱۴۰۳",
    text: "راه‌بهشت ۱۴۰۳",
  },
  {
    link: "/gallery",
    text: "گزارش تصویری",
  },
  {
    link: "/rb1403/catalog",
    text: "بخش های برنامه",
  },
  {
    link: "/rb1403/blog?search=سخنرانی_مداحی",
    text: "سخنرانی و مداحی",
  },
  {
    link: "/rb1403/vow",
    text: "نذر بهشت",
  },
  {
    link: "/rb1403/blog?search=عصرگاه_بهشتی",
    text: "عصرگاه بهشتی",
  },
];

export const catalogitems = [
  {
    link: "#",
    text: "تیزر راه‌بهشت ",
    video:
      "https://app.rahebehesht.com/wp-content/uploads/2024/07/Teaser-RaheBehesht1403.mp4",
  },
  {
    link: "https://app.rahebehesht.com/?page_id=1940",
    text: "خادمان راه‌بهشت",
  },
  {
    link: "/rb1403/blog?search=عصرگاه_بهشتی",
    text: "عصرگاه بهشتی",
  },
  {
    link: "/rb1403/blog?search=گزارش_ویدئویی",
    text: "گزارش ویدئویی",
  },
  {
    link: "/rb1403/blog?search=نذر",
    text: "خیر ماندگار",
  },
  {
    link: "/rb1403/blog?search=هیئت_پرماجرا",
    text: "هیئت پرماجرا",
    // video:
    //   "https://api.v2.rahebehesht.com/file/get/IMG_20240723_085042_597_1721712230.mp4",
  },
  {
    link: "/rb1403/blog?search=مهد_کودکان_بهشت",
    text: "مهد کودکان بهشت",
  },
  {
    link: "/rb1403/blog?search=هیئت_عبدالله_بن_حسن",
    text: `هیئت عبدالله بن حسن <span>علیه السلام<span>`,
  },
  {
    link: "/rb1403/blog?search=تئاتر",
    text: "تئاتر",
  },
  {
    link: "/rb1403/blog?search=عبرت_تاریخ_نشویم",
    text: "عبرت تاریخ نشویم",
  },
  {
    link: "/rb1403/blog?search=نقاشی_شنی_کودکانه",
    text: "نقاشی شنی کودکانه",
  },
  {
    link: "/rb1403/blog?search=جمع_خوانی_کودکانه",
    text: "جمع خوانی کودکانه",
  },
  // {
  //   link: "#",
  //   text: "گذر بهشتی",
  // },
  // {
  //   link: "#",
  //   text: "مسابقه کتابخوانی والد سوم",
  // },
  // {
  //   link: "#",
  //   text: "پاتوق کفتگو",
  // },
];
